"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptInline = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var PromptDismissible_1 = require("./PromptDismissible");
var PromptInline = function (_a) {
    var promptId = _a.promptId, heading = _a.heading, headingIcon = _a.headingIcon, content = _a.content, className = _a.className, theme = _a.theme, type = _a.type;
    return (react_1.default.createElement(PromptDismissible_1.PromptDismissible, { promptId: promptId, className: "prompt-inline-root ".concat(className) },
        react_1.default.createElement(kaleidoscope_1.Alert, { heading: heading, headingIcon: headingIcon, theme: theme || kaleidoscope_1.AlertTheme.Dark, alertType: type || kaleidoscope_1.AlertType.Info },
            react_1.default.createElement("p", null, content))));
};
exports.PromptInline = PromptInline;
